import { useCallback, useEffect, useState } from 'react'
import classNames from 'classnames'
import { createUseStyles } from 'react-jss'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import useUpdateEffect from '@/hooks/useUpdateEffect'
import Logo from '@/components/Logo'
import DelayLink from '@/components/DelayLink'
import Form from '@/components/Form'
import actions from '@/actions'
import utils from '@/utils'
import style from './style'

const useStyles = createUseStyles(style)

const Footer = ({
  noMargin,
  newsletter,
}) => {
  const classes = useStyles()
  const [feedback, setFeedback] = useState({})

  /*------------------------------
  Redux Store
  ------------------------------*/
  const { footerNav, copyrightNav, strings, response, form } = useSelector((state) => ({
    footerNav: state.nav.footerMenu || [],
    copyrightNav: state.nav.copyrightMenu || [],
    strings: state.language.string,
    response: state.page.status_form,
    form: state.page.forms,
  }), shallowEqual)

  /*------------------------------
  Redux Actions
  ------------------------------*/
  const dispatch = useDispatch()
  const resetForm = useCallback(() => dispatch(actions.page.resetForm()), [dispatch])
  const sendForm = useCallback((index, params) => dispatch(actions.page.sendForm(index, params)), [dispatch])
  const sendDataToCallback = useCallback((data) => dispatch(actions.page.sendDataToCallback(data)), [dispatch])
  const getForm = useCallback((index) => dispatch(actions.page.getDataForm(index)), [dispatch])

  useEffect(() => {
    getForm(strings.newsletter_id_form)
  }, [])

  useUpdateEffect(() => {
    setFeedback(response)
  }, [response])

  const renderNewsletter = () => {
    return newsletter && (
      <div
        className={classNames({
          [classes.root]: true,
          [classes.newsletter]: true,
          [classes.noMargin]: noMargin,
        })}
      >
        <div className={classes.container}>
          <div className={classes.wrapper}>
            <div
              className={classes.copy}
              dangerouslySetInnerHTML={{ __html: strings.newsletter_copy }}
            />
            <div className={classes.form}>
              {form?.[strings.newsletter_id_form] && (
                <Form
                  data={form[strings.newsletter_id_form].data}
                  newsletter={strings.newsletter_privacy_label}
                  newsletterLink={utils.path.cleanOrigin(strings.newsletter_privacy_link)}
                  labelSubmit={strings.newsletter_privacy_send}
                  resetForm={resetForm}
                  sendForm={(value) => sendForm(strings.newsletter_id_form, value)}
                  parent={this}
                  response={feedback}
                  mailchimpCallback={(data) => sendDataToCallback(data)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  const renderFooter = () => {
    return (
      <footer className={`${classes.root} ${classes.footer}`}>
        <div
          className={classNames({
            [classes.container]: true,
            [classes.containerNewsletter]: !newsletter,
          })}
        >
          <div className={classes.wrapper}>
            <div className={classes.left}>
              <div className={classes.logo}>
                <Logo />
              </div>
              <div className={classes.copy}>
                <div
                  className={classes.text}
                  dangerouslySetInnerHTML={{ __html: strings.footer_copy }}
                />
                <div className={classes.copyright}>
                  <ul className={`${classes.menu} ${classes.copyrightMenu}`}>
                    {copyrightNav.map((item) => (
                      <li key={item.ID}>
                        <DelayLink to={item.url}>
                          {item.title}
                        </DelayLink>
                      </li>
                    ))}
                  </ul>
                  <div dangerouslySetInnerHTML={{ __html: strings.footer_copy2 }} />
                </div>
              </div>
            </div>
            <div className={classes.right}>
              <ul className={`${classes.menu} ${classes.footerMenu}`}>
                {footerNav.map((item) => (
                  <li key={item.ID}>
                    <DelayLink to={item.url}>
                      {item.title}
                    </DelayLink>
                  </li>
                ))}
              </ul>
              <div className={classes.social}>
                {strings.instagram_url && (
                  <>
                    {strings.footer_follow_us}
                    <a
                      href={strings.instagram_url}
                      target="_blank"
                    >
                      {strings.instagram_label}
                    </a>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </footer>
    )
  }

  return (
    <>
      {renderNewsletter()}
      {renderFooter()}
    </>
  )
}

Footer.defaultProps = {
  newsletter: true,
}

export default Footer
